import { reactive, toRefs, onMounted } from 'vue';
export default {
  name: "AddAside",
  components: {},
  props: {
    procs: {
      type: Array
    }
  },
  setup(props, context) {
    const data = reactive({
      activeTab: 'first'
    });
    onMounted(() => {
      console.log('props.procs: ', props.procs);
    });
    return {
      ...toRefs(data)
    };
  }
};